import FilterMenu from './FilterMenu'
import type { FilterOption } from 'src/data/browse/filters'

interface FilterProps<FilterArrayItem> {
  queryKey: string
  name: string
  options: FilterOption<FilterArrayItem>[]
  onChange: (value: FilterArrayItem[] | null) => void
  value: FilterArrayItem[] | null
}

export default function Filter<FilterArrayItem>({
  queryKey,
  name,
  options,
  onChange,
  value
}: FilterProps<FilterArrayItem>) {
  const activeCnt = Array.isArray(value) ? value.length : 0

  const handleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const checked = e.target.checked
    const option = options.find(
      (o) => (o.value as unknown as string) === e.target.value
    ) as FilterOption<FilterArrayItem>

    if (checked) {
      onChange([...(value || []), option.value])
    } else {
      const result = value?.filter((v) => v !== option.value) || null
      const update = Array.isArray(result) && result.length > 0 ? result : null
      onChange(update)
    }
  }

  return (
    <FilterMenu name={name} activeCnt={activeCnt}>
      <div className="space-y-4">
        {options.map((option, optionIdx) => (
          <div key={option.value as unknown as string} className="flex items-center">
            <input
              id={`filter-${queryKey}-${optionIdx}`}
              name={`${queryKey}[]`}
              value={option.value as unknown as string}
              type="checkbox"
              checked={value?.includes(option.value) || false}
              className="h-4 w-4 border-gray-300 rounded text-brand-500 focus:ring-brand-500"
              onChange={handleChange}
            />
            <label
              htmlFor={`filter-${queryKey}-${optionIdx}`}
              className="ml-3 pr-6 text-sm font-medium text-gray-900 whitespace-nowrap"
            >
              {option.label}
            </label>
          </div>
        ))}
      </div>
    </FilterMenu>
  )
}
